module.exports = __webpack_public_path__ + "static/media/sort-shapes-down-alt.047c8d31.svg";